export const getSatser = async (): Promise<Satser> => {
    const response = await fetch('/api/mt1535/satser/BorteboerLarling');

    if (!response.ok) {
        throw response;
    }

    return await response.json();
};

export interface Satser {
    ST01_MaksBostipendManed: number;
    ST01_BostipendLaringelonnNedreGrenseTrekk: number;
    ST01_BostipendLaringelonnReduksjonsfaktor: number;
}
